import React from 'react'
import { useTranslation } from 'react-i18next'
import Footer from '../../Footer'
import './outOfService.less'

const Component: React.FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className="out-of-service">
        <div className="title">{t('outOfService')}</div>
        <div className="message">{t('turnToCheckInCounter')}</div>
      </div>
      <Footer noExit />
    </>
  )
}

export default Component
